import { object, string } from 'yup'

const validateAuthByCodeForm = object().shape({
  identifiant: string()
    .required('Veuillez saisir un identifiant')
    .min(7, "L'identifiant doit contenir au moins 7 chiffres.")
    .max(7, "L'identifiant doit contenir au maximum 7 chiffres"),
})

export default validateAuthByCodeForm
